import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WebpUrlPipe} from '../../pipes/webp-url/webp-url.pipe';

@Component({
  selector: 'app-webp-image',
  standalone: true,
  imports: [CommonModule, WebpUrlPipe],
  templateUrl: './webp-image.component.html',
  styleUrls: ['./webp-image.component.css']
})
export class WebpImageComponent {
  @Input() src!: string;
  @Input() alt: string = '';
  @Input() title: string = '';
  @Input() imgClass: string = '';
  @Input() imgStyle: any = null;
}
